import * as React from "react"
import SVGArrowDown from "../../../assets/icons/SVGArrowDown";

interface Prop {
    id: string;
    label: string;
    isShowNewBadge?: boolean;
}

const NavBarItemDropdownMenu: React.FC<Prop> = (props) => {
    // tmp
    const [shouldShowDropdown, setShouldShowDropdown] = React.useState(false);
    const [delayHandler, setDelayHandler]: any = React.useState(null)

    const onMouseEnter = () => {
        setShouldShowDropdown(true);
        clearTimeout(delayHandler);
    }    
    
    const onMouseLeave = () => {
        setDelayHandler(setTimeout(() => {
            setShouldShowDropdown(false);
        }, 30));
    }

    return (
        <li className="dropdown-nav-item" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} key={props.id}>
            <button id={props.id} type="button" aria-haspopup="false" aria-expanded="false" className="top-nav-bar-item-dropdown-menu__link js-hover-dropdown-link nav-link btn btn-link dropdown-toggle">
                { props.isShowNewBadge && <span className="badge new">全新</span> }
                <span className="nav-label">
                    {/* { t(props.label) } */}
                    { props.label }
                </span>
                <SVGArrowDown />
                { shouldShowDropdown }
            </button>
            <div className={`dropdown-nav-menu ${shouldShowDropdown ? 'show' : ''}`} aria-labelledby={props.id}>
                { props.children }
            </div>
        </li>
    );
}

export default NavBarItemDropdownMenu;